import { Component } from 'react';
import fileIcon from '../../../_shared/assets/erin_lightgray.png';
import { USER_ROLES } from '../../../_shared/constants';
import { getSetErrorImageURL, ml } from '../../../_shared/services/utils.js';

export class JobCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorImageURL: '',
		};
	}

	async componentDidMount() {
		const { currentUser } = this.props;
		const errorImageURL = await getSetErrorImageURL(
			currentUser?.company?.errorImage?.key
		);

		if (errorImageURL) {
			this.setState({ errorImageURL });
		}
	}

	render() {
		const { allMultiLingualData, onClick, title, openPositions, currentUser } =
			this.props;

		const { errorImageURL } = this.state;

		const whiteLabel = currentUser?.company?.whiteLabel;

		return (
			<div className="d-card height-equal">
				<div className="d-card-head">
					<h4 className="d-title">{title}</h4>
				</div>

				{(currentUser.displayAs === USER_ROLES.EMPLOYEE ||
					currentUser.displayAs === USER_ROLES.MANAGER) && (
					<div className="d-card-body vh-center" style={{ cursor: 'pointer' }}>
						{openPositions ? (
							<div className="text-center">
								<h3 className="d-number">{openPositions}</h3>
								<p className="d-info ant-btn-link" onClick={onClick}>
									{ml('Open Jobs', currentUser, allMultiLingualData)}
								</p>
							</div>
						) : (
							<div className="no-content">
								{whiteLabel ? (
									<img
										src={errorImageURL}
										alt="error image"
										className="no-content-icon"
									/>
								) : (
									<img
										alt="erin-logo"
										className="no-content-icon"
										src={fileIcon}
									/>
								)}
								<p className="no-content-text">
									{ml(
										'There currently are no open jobs.',
										currentUser,
										allMultiLingualData
									)}
								</p>
							</div>
						)}
					</div>
				)}
			</div>
		);
	}
}
